import { replaceDate } from "@/helper/dateHandling";

export function auditDateLabel(text: string): string | null {
  const match =
    /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2})(?:\.\d{1,9})?)?(Z|[+-]\d{2}:?\d{2})?)?$/.exec(
      text
    );
  if (!match) return null;
  const [, year, month, day, hour, minute, seconds, zone] = match;
  const date = `${year}-${month}-${day}`;
  const calendar = new Date(`${date}T00:00:00Z`);
  if (
    calendar.getUTCFullYear() !== Number(year) ||
    calendar.getUTCMonth() + 1 !== Number(month) ||
    calendar.getUTCDate() !== Number(day)
  )
    return null;
  const dateLabel = `${day}.${month}.${year}`;
  if (hour === undefined) return dateLabel;
  const second = seconds ?? "00";
  if (Number(hour) > 23 || Number(minute) > 59 || Number(second) > 59)
    return null;
  const time = `${hour}:${minute}:${second}`;
  if (!zone) return `${dateLabel}, ${time}`; // Historical values without an offset do not establish a timezone.
  const offset = zone.replace(/^([+-]\d{2})(\d{2})$/, "$1:$2");
  const timestamp = new Date(`${date}T${time}${offset}`);
  if (Number.isNaN(timestamp.getTime())) return null;
  return replaceDate(timestamp, true, true);
}
